var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLittleGermanyFlag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 2.66666C10.2807 2.66666 5.41667 6.27466 3.52267 11.3333H28.4767C26.5833 6.27466 21.7193 2.66666 16 2.66666Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3333 16C29.3333 14.3553 29.0213 12.788 28.4773 11.3333H3.52266C2.97866 12.788 2.66666 14.3553 2.66666 16C2.66666 17.6447 2.97866 19.212 3.52266 20.6667H28.4767C29.0213 19.212 29.3333 17.6447 29.3333 16Z",
    fill: "#DA0E13"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4773 20.6667H3.52267C5.41667 25.7253 10.2807 29.3333 16 29.3333C21.7193 29.3333 26.5833 25.7253 28.4773 20.6667Z",
    fill: "#FDD44B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLittleGermanyFlag);
export default __webpack_public_path__ + "static/media/little-germany-flag.a87c3a830b0b0b3f8ea06d1012d2c735.svg";
export { ForwardRef as ReactComponent };